<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_1"></a><a id="part1"></a>PART I<br/><br/><strong>In the Beginning</strong></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?7ba07d36